import React, { useCallback } from 'react';

import { IconButton } from '@atlaskit/button/new';
import Tooltip from '@atlaskit/tooltip';

import { useHerStore } from '../hooks/useHerStore';

import { HerIcon } from './HerIcon';

export function HerButton({
	contentId,
	cloudId,
	contentType,
}: {
	contentId: string;
	cloudId: string;
	contentType: string;
}): React.JSX.Element {
	const { isHerActive, toggleHer } = useHerStore();

	const handleClick = useCallback(() => {
		toggleHer(contentId, cloudId, contentType);
	}, [toggleHer, contentId, cloudId, contentType]);

	return (
		<Tooltip content="Enterprise HER" position="left">
			<IconButton
				appearance="subtle"
				icon={() => <HerIcon />}
				label="Enterprise HER"
				shape="circle"
				isSelected={isHerActive}
				onClick={handleClick}
				testId="enterprise-her-button"
			/>
		</Tooltip>
	);
}
